import { createSelector } from 'reselect';
import UserDatabases from '@Services/UserDatabases';
import { findSimilarModalReducerKey } from './FindSimilarModalConstants';

export const findSimilarModal = (state) => {
  return state.get(findSimilarModalReducerKey);
};

export const isLoading = (state) => {
  return findSimilarModal(state).get('isLoading');
};

export const data = (state) => {
  return findSimilarModal(state).get('data');
};

export const currentDb = (state) => {
  return findSimilarModal(state).get('currentDb');
};

export const databasesOrder = (state) => {
  return findSimilarModal(state).get('databasesOrder');
};

export const availableDatabases = (state) => {
  return findSimilarModal(state).get('availableDatabases');
};

// eslint-disable-next-line no-shadow
export const itemsForDB = createSelector([data, currentDb], (data, currentDb) => {
  if (!data || !data.items) {
    return [];
  }
  if (!currentDb || !currentDb.databaseId) {
    return data.items;
  }
  return data.items.filter((item) => item.databaseId === currentDb.databaseId);
});

// eslint-disable-next-line no-shadow
export const modalTitle = createSelector([data, currentDb], (data, currentDb) => {
  if (!data || !data.title) {
    return;
  }

  if (!currentDb) {
    // eslint-disable-next-line consistent-return
    return data.title;
  }
  // eslint-disable-next-line consistent-return
  return currentDb.dbName ? data.title.replace('...', ` in ${currentDb.dbName}`) : data.title;
});

// eslint-disable-next-line no-shadow
export const itemsForCurrentDB = createSelector([data, currentDb], (data, currentDb) => {
  if (!data || !data.items || !currentDb) {
    return [];
  }

  return data.items.filter((item) => item.databaseId === currentDb.databaseId);
});

// eslint-disable-next-line no-shadow
export const itemsForAvailableDB = createSelector([data, availableDatabases], (data, availableDatabases) => {
  if (!data || !data.items || !availableDatabases) {
    return [];
  }

  return availableDatabases.map((databaseId) => {
    return {
      items: data.items.filter((item) => item.databaseId === databaseId),
      name: UserDatabases.getDbName(databaseId),
    };
  });
});
